export default function format_BusQueryDate(dateString) {
    return dateString.replace(/(\d{4})(\d{2})(\d{1})/, '$1-$2-$3');
  }
  